import spinner from "../assets/spinner.gif"

export default function Spinner(){
  return <img style={{
    width: '50px',
    margin: 'auto'
  }} src={spinner} />
}